import React, { useState } from 'react';

import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Paper from '@mui/material/Paper';
import Slide from '@mui/material/Slide';
import FormControlLabel from '@mui/material/FormControlLabel';

import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import SvgIcon from "@mui/material/SvgIcon";
import Icon from "@mui/material/Icon";
import Stack from '@mui/material/Stack';

import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';

import Slider from '@mui/material/Slider';

import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Divider from '@mui/material/Divider';

import ButtonGroup from '@mui/material/ButtonGroup';

import SettingsIcon from '@mui/icons-material/Settings';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import FastRewindIcon from '@mui/icons-material/FastRewind';
import FastForwardIcon from '@mui/icons-material/FastForward';
import MenuIcon from '@mui/icons-material/Menu';

import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';

import AudiotrackIcon from '@mui/icons-material/Audiotrack';

import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import CreateIcon from '@mui/icons-material/Create';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';

import BorderColorIcon from '@mui/icons-material/BorderColor';
import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice';
import PrintIcon from '@mui/icons-material/Print';
import DownloadIcon from '@mui/icons-material/Download';
import TuneIcon from '@mui/icons-material/Tune';
import PauseIcon from '@mui/icons-material/Pause';
import { ReactComponent as MetronomeIcon } from "../29689/metronome.svg";

import InfoIcon from '@mui/icons-material/Info';

import { ThemeProvider, createTheme } from '@mui/material/styles';

import PlaybackSettingsPage from "./PlaybackSettingsPage.js"
import PrintingPage from "./PrintingPage.js"
import SettingsPage from "./SettingsPage.js"
import ScoreManagementPage from "./ScoreManagementPage.js"
import Keyboard from "./Keyboard/Keyboard.js"
import AnnotationToolbar from "./AnnotationToolbar.js"
import RecordingToolbar from "./RecordingToolbar.js"

import ScoreDisplayer from '../ScoreDisplayer';

import settingSystem from "../SettingSystem.js"
import AnnotationCanvas from './AnnotationCanvas';
import SheetMusicPlayer from './SheetMusicPlayer';
import RenderBlocker from './RenderBlocker';
import NumberInput from './NumberInput';

import TextManager from "../TextManager.js"

const TOOLBAR_STATUS_HIDDEN = 0;
const TOOLBAR_STATUS_ANNOTATION = 1;
const TOOLBAR_STATUS_RECORDING = 2;

const NavigationBarResponsiveWidth = "800px";

export default class MainBar extends React.Component {


	state = {

		lastToolbarStatus: TOOLBAR_STATUS_HIDDEN, // this is for the slide animation
		toolbarStatus: TOOLBAR_STATUS_HIDDEN,

		isNarrowScreen: window.matchMedia(`(max-width: ${NavigationBarResponsiveWidth})`).matches,

		navigationMenuOpened: false,
		navigationMenuAnchor: null,

		windowHeight: "100vh",

		isPlaying: ScoreDisplayer.singleton.state.isPlaying,

		showKeyboard: true,
		alwaysShowFullKeyboard: true,
	};

	constructor(props) {
		super(props);
		MainBar.singleton = this;

		settingSystem.registerMember("showKeyboard", this, "showKeyboard");
		settingSystem.registerMember("alwaysShowFullKeyboard", this, "alwaysShowFullKeyboard");
	}

	onClicks = this.props.onClicks;

	get showKeyboard() {
		return this.state.showKeyboard;
	}
	set showKeyboard(v) {
		this.setState({ showKeyboard: v });
	}

	get alwaysShowFullKeyboard() {
		return this.state.alwaysShowFullKeyboard;
	}
	set alwaysShowFullKeyboard(v) {
		this.setState({ alwaysShowFullKeyboard: v });
	}

	resizeToFitInnerHeight() {
		if (this.state.windowHeight != window.innerHeight) {
			this.setState({ windowHeight: window.innerHeight });
		}
	}

	componentDidMount() {
		window.addEventListener('resize', () => {
			this.resizeToFitInnerHeight();

			this.setState({
				navigationMenuOpened: false,
				isNarrowScreen: window.matchMedia(`(max-width: ${NavigationBarResponsiveWidth})`).matches,
			});
		});

		this.resizeToFitInnerHeight();
	}

	setPlayingState(isPlaying) {
		this.setState({ isPlaying: isPlaying });
	}

	render() {
		const openAnnotationToolbar = () => {
			if (this.props.welcomePageOpened) { return; }
			// [TEMP]
			// if (this.props.annotationCanvasRef.current == null) {
			// 	return;
			// }

			this.setState(
				{
					toolbarStatus: (this.state.toolbarStatus == TOOLBAR_STATUS_ANNOTATION) ? TOOLBAR_STATUS_HIDDEN : TOOLBAR_STATUS_ANNOTATION,
					lastToolbarStatus: TOOLBAR_STATUS_ANNOTATION,
				},
				() => {
					if (ScoreDisplayer.singleton != null && ScoreDisplayer.singleton.scoreRangeSelectorRef.current != null) {
						ScoreDisplayer.singleton.scoreRangeSelectorRef.current.setState({ visible: false });
					}
					settingSystem.setSetting("annotationDisabled", this.state.toolbarStatus != TOOLBAR_STATUS_ANNOTATION, this)
				}
			)

		};

		const openRecordingToolbar = () => {
			if (this.props.welcomePageOpened) { return; }

			this.setState(
				{
					toolbarStatus: (this.state.toolbarStatus == TOOLBAR_STATUS_RECORDING) ? TOOLBAR_STATUS_HIDDEN : TOOLBAR_STATUS_RECORDING,
					lastToolbarStatus: TOOLBAR_STATUS_RECORDING,
				},
				() => {
					settingSystem.setSetting("annotationDisabled", this.state.toolbarStatus != TOOLBAR_STATUS_ANNOTATION, this)
				}
			)

		};

		const openNavigationMenu = (event) => {
			this.setState({ navigationMenuAnchor: event.currentTarget });
			this.setState({ navigationMenuOpened: true });
		}

		const closeNavigationMenu = (event) => {
			this.setState({ navigationMenuOpened: false });
		}

		const createNavBarButton = (Icon, text, onClick, isSvgIcon = false) => {
			var IconObj = null;

			if (isSvgIcon) {
				IconObj = (
					<SvgIcon htmlColor="white" fontSize="small" sx={{ height: "100%", width: "auto" }} >
						<Icon />
					</SvgIcon>
				)

			} else {
				IconObj = (
					<Icon sx={{ color: "white", height: "100%", width: "auto" }} />
				)
			}

			return (
				<IconButton size="small" sx={{
					boxSizing: "border-box",
					width: "60px",
					height: "100%",
					borderRadius: "0px"

				}} onClick={onClick}>

					<Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" height="100%" sx={{
						boxSizing: "border-box",
						padding: "8px 0px 8px 0px"
					}}>
						{IconObj}
						<span style={{
							color: "white",
							fontSize: "14px",
						}}>{text}</span>
					</Box>

				</IconButton>
			)
		};

		const gradient =
			<Box sx={{ maxHeight: 0 }}>
				<svg viewBox="0 0 0 0" width="0" height="0" sx={{ overflow: "hidden" }}>
					<linearGradient id="gradientId" x1={0} y1={0} x2={1} y2={0}>
						<stop offset={0} stopColor="rgba(0,141,254,1)" />
						<stop offset={1} stopColor="rgba(81,202,255,1)" />

					</linearGradient>
				</svg>
			</Box>

		const createNavBarMenuItem = (Icon, text, onClick, isSvgIcon = false) => {
			var IconObj = null;

			if (isSvgIcon) {
				IconObj = (
					<SvgIcon fontSize="small" sx={{ fill: "url(#gradientId)" }}>
						<Icon />
					</SvgIcon>
				)

			} else {
				IconObj = (
					<Icon sx={{ fill: "url(#gradientId)" }} />
				)
			}

			return (
				<MenuItem onClick={
					(event) => {
						onClick(event);
						closeNavigationMenu();
					}
				} >
					<ListItemIcon>{IconObj}</ListItemIcon>
					<ListItemText>{text}</ListItemText>
				</MenuItem>
			)
		};

		const createToolbarWrapper = (Toolbar, toolbarState) => {
			return (
				<Slide direction="up" in={toolbarState} mountOnEnter unmountOnExit>
					<Box sx={{
						// overflow:"hidden",
						// [`@media (max-width: ${NavigationBarResponsiveWidth})`]: {
						// overflowX:"scroll",
						// },

						overflow: "scroll",

						width: "100%",



						// // overflow:"clip",
						// overflowY:"visible",
						// overflowX:"scroll",

						// ".MuiSlider-valueLabel": {
						// position: "absolute",
						// },

						boxShadow: "0 0 15px rgba(0,0,0,1.0)",
						zIndex: 1,

						backgroundColor: "rgba(255,255,255,1.0)",



						"::-webkit-scrollbar": {
							display: "none",
						},
						scrollbarWidth: "none",
					}}>
						<Box sx={{
							width: "fit-content",
							margin: "auto auto",
							padding: "0 10px"
						}}>
							{Toolbar}
						</Box>
					</Box>
				</Slide>
			)
		}

		let toolbar = null;
		if (this.state.lastToolbarStatus == TOOLBAR_STATUS_ANNOTATION) {
			if (AnnotationCanvas.singleton != null) {
				toolbar = (<AnnotationToolbar />)
			}
		} else if (this.state.lastToolbarStatus == TOOLBAR_STATUS_RECORDING) {
			toolbar = (<RecordingToolbar />)
		}

		return (
			<div>


				{gradient} {/* for later reference */}


				<Box
					sx={{
						position: "relative",
						bgcolor: "red",
						width: "100%",
						height: "0px",
						top: "0px"
					}}
				>

					<Box
						sx={{
							position: "absolute",
							// bgcolor: "red",
							// width: "100px",
							// height: "100px",

							right: this.state.isNarrowScreen ? "10px" : "30px",
							bottom: this.state.isNarrowScreen ? "5px" : "10px",

							zIndex: 2,
						}}
					>
						<RenderBlocker
							sx={{ width: "100%", height: "100%" }}
							state={{
								welcomePageOpened: this.props.welcomePageOpened,
							}}
						>
							<ButtonGroup
								orientation="horizontal"
								sx={{
									visibility: this.props.welcomePageOpened ? "hidden" : null,
									bgcolor: "rgba(255,255,255,0.75)"
								}}
							>
								<Button onClick={(event) => {
									// SheetMusicPlayer.singleton.pause();
									settingSystem.setSetting("zoomLevel", settingSystem.getSetting("zoomLevel") - 0.1, this);
								}} size="small" sx={{
									width: "40px",
									height: "40px",
								}}>
									<ZoomOutIcon sx={{ width: "140%", height: "140%" }} />
								</Button>
								<Button onClick={(event) => {
									// SheetMusicPlayer.singleton.pause();
									settingSystem.setSetting("zoomLevel", settingSystem.getSetting("zoomLevel") + 0.1, this);
								}} size="small" sx={{
									width: "40px",
									height: "40px",
								}}>
									<ZoomInIcon sx={{ width: "140%", height: "140%" }} />
								</Button>
							</ButtonGroup>
						</RenderBlocker>
					</Box>

				</Box>


				<AppBar position="static" sx={{
					boxShadow: 0,
					backgroundColor: "rgba(0,0,0,0.0)",
					// top: 'auto', 
					// bottom: 0, 
					display: "border-box",
					// overflow: "hidden",
					// display: "none"
				}}>



					<Slide direction="up" in={this.state.showKeyboard} mountOnEnter
						onEntered={(element) => {
							element.style.display = "unset"
						}}
						onExited={(element) => {
							element.style.display = "none"
						}}
					>
						<Box sx={{
							overflow: "hidden",
							[`@media (max-width: ${NavigationBarResponsiveWidth})`]: {
								overflowX: "scroll",
							},


							"::-webkit-scrollbar": {
								display: "none",
							},
							scrollbarWidth: "none",

							boxShadow: "0 0 15px rgba(0,0,0,0.4)",

							zIndex: 1,
						}}>
							<RenderBlocker
								sx={{ width: "100%", height: "100%" }}
								state={{
									alwaysShowFullKeyboard: this.state.alwaysShowFullKeyboard,
									isNarrowScreen: this.state.isNarrowScreen,
									welcomePageOpened: this.props.welcomePageOpened,
								}}
							>
								<Box sx={{
									width: "100%",
									height: "80px",
									// minHeight:"6vw",
									// maxHeight:"20vh",
									bgcolor: "black",

									overflow: "hidden",

									// padding: "2px 0px 2px 0px",
									// padding: "0.2vh 0px 0.2vh 0px",
									paddingTop: "clamp(1px,0.2vh, 2px)",
									paddingBottom: "clamp(1px,0.2vh, 2px)",
									boxSizing: "border-box",

									[`@media (max-width: ${NavigationBarResponsiveWidth})`]: {
										width: this.state.alwaysShowFullKeyboard ? null : "1200px",
										height: this.state.alwaysShowFullKeyboard ? "30px" : "60px"
									},
								}}>

									<Box sx={{
										width: "100.2%",
										height: "100%",
									}}> {/* a wrapper to hide gaps after the last keys */}

										<Keyboard 
											isCompactKeyboard={this.state.alwaysShowFullKeyboard && this.state.isNarrowScreen} 
											welcomePageOpened={this.props.welcomePageOpened}
										/>

									</Box>

								</Box>
							</RenderBlocker>
						</Box>
					</Slide>

					<Slide direction="up" in={this.state.toolbarStatus != TOOLBAR_STATUS_HIDDEN} mountOnEnter unmountOnExit>
						<Box sx={{
							position: "relative",
							height: "fit-content",
						}}>
							<Box sx={{
								// overflow:"hidden",
								// [`@media (max-width: ${NavigationBarResponsiveWidth})`]: {
								// overflowX:"scroll",
								// },
								position: "relative",


								overflow: "scroll",

								width: "100%",

								// // overflow:"clip",
								// overflowY:"visible",
								// overflowX:"scroll",

								// ".MuiSlider-valueLabel": {
								// position: "absolute",
								// },

								boxShadow: "0 0 10px rgba(0,0,0, 1.0)",
								// zIndex: 1,

								backgroundColor: "rgba(255,255,255,1.0)",



								"::-webkit-scrollbar": {
									display: "none",
								},
								scrollbarWidth: "none",
							}}>
								<Box sx={{
									width: "100%",
									boxSizing: "border-box",
									// margin: "auto auto",
									padding: "0 15px"
								}}>
									{toolbar}
								</Box>
							</Box>

							{/* <Box
								sx={{
									position: "absolute",
									background: "linear-gradient(90deg, rgba(255,255,255, 0.0), rgba(255,255,255, 1.0) 50%)",
									width: "40px",
									height: "100%",
									right: "0",
									top: "0",
									pointerEvents: "none",
								}}
							>
								<IconButton sx={{
									position: "absolute",
									pointerEvents: "initial",
									width: "30px",
									height: "100%",
									marginTop: "auto",
									marginBottom: "auto",
									right: "0",
									top: 0,
									bottom: 0,

									":hover": {
										borderRadius: 0,
									},

									":focus": {
										borderRadius: 0,
									},
								}}>
									<NavigateNextIcon sx={{fill: "black"}}/>
								</IconButton>
							</Box> */}
						</Box>
					</Slide>

					<RenderBlocker
						sx={{
							width: "100%",
							height: "100%"
						}}
						state={{
							isPlaying: this.state.isPlaying,
							welcomePageOpened: this.props.welcomePageOpened,
							language: TextManager.language,
						}}
					>
						<Toolbar variant="dense" disableGutters={true} sx={{
							justifyContent: "center",
							backgroundImage: "linear-gradient(90deg, rgba(0,141,254,1) 0%, rgba(81,202,255,1) 100%)",
							boxShadow: "0px 0px 15px 0px rgba(0, 117, 255, 1.0)",
							zIndex: 2,
							padding: "0px 10px 0px 10px"
						}}>

							{createNavBarButton(MenuIcon, TextManager.getText("menu"), openNavigationMenu)}


							<Box sx={{
								[`@media (max-width: ${NavigationBarResponsiveWidth})`]: { display: "none" },
								height: "100%"
							}}>
								{/*createNavBarButton(SettingsIcon, "Settings", this.onClicks["settingsButton"])*/}
								{/*createNavBarButton(PrintIcon, "Export", this.onClicks["exportButton"])*/}
								{createNavBarButton(AudiotrackIcon, TextManager.getText("playback"), this.onClicks["playbackButton"])}
								{createNavBarButton(KeyboardVoiceIcon, TextManager.getText("record"), openRecordingToolbar)}
								{createNavBarButton(BorderColorIcon, TextManager.getText("annotate"), openAnnotationToolbar)}
								{/*createNavBarButton(AudioFileIcon, "Score", this.onClicks["scoreButton"])*/}
							</Box>

							<Box sx={{
								[`@media (max-width: ${NavigationBarResponsiveWidth})`]: { display: "none" },
								background: "white",
								width: "1px",
								height: "70%",
								margin: "0px 20px 0px 20px"
							}} />

							{createNavBarButton(FastRewindIcon, TextManager.getText("back"), () => {
								if (this.props.welcomePageOpened) { return; }

								SheetMusicPlayer.singleton.seekPreviousMeasure();
							})}
							{createNavBarButton(
								this.state.isPlaying ? PauseIcon : PlayArrowIcon,
								this.state.isPlaying ? TextManager.getText("pause") : TextManager.getText("play"),
								() => {
									if (this.props.welcomePageOpened) { return; }

									// var callback = () => {
									// 	// console.log(this.props);
									// 	this.setState({isPlaying: ScoreDisplayer.singleton.state.isPlaying})
									// };

									SheetMusicPlayer.singleton.playOrPause();
									// this.onClicks["playButton"](callback);
								}
							)}
							{createNavBarButton(StopIcon, TextManager.getText("stop"), () => {
								if (this.props.welcomePageOpened) { return; }

								SheetMusicPlayer.singleton.stop();
							})}
							{createNavBarButton(FastForwardIcon, TextManager.getText("next"), () => {
								if (this.props.welcomePageOpened) { return; }

								SheetMusicPlayer.singleton.seekNextMeasure();
							})}


						</Toolbar>
					</RenderBlocker>

					<Menu
						disableAutoFocusItem={true}
						anchorEl={this.state.navigationMenuAnchor}
						anchorOrigin={{
							vertical: 'top',
							horizontal: 'left',
						}}
						transformOrigin={{
							vertical: 'bottom',
							horizontal: 'left',
						}}
						open={this.state.navigationMenuOpened}
						onClose={closeNavigationMenu}
					>
						{createNavBarMenuItem(InfoIcon, TextManager.getText("about"), this.onClicks["aboutButton"])}
						{createNavBarMenuItem(SettingsIcon, TextManager.getText("settings"), this.onClicks["settingsButton"])}
						{createNavBarMenuItem(DownloadIcon, TextManager.getText("export"), this.onClicks["exportButton"])}
						{!this.state.isNarrowScreen ? null : createNavBarMenuItem(AudiotrackIcon, TextManager.getText("playback"), this.onClicks["playbackButton"])}
						{!this.state.isNarrowScreen ? null : createNavBarMenuItem(KeyboardVoiceIcon, TextManager.getText("record"), openRecordingToolbar)}
						{!this.state.isNarrowScreen ? null : createNavBarMenuItem(BorderColorIcon, TextManager.getText("annotate"), openAnnotationToolbar)}
						{createNavBarMenuItem(AudioFileIcon, TextManager.getText("score"), this.onClicks["scoreButton"])}
					</Menu>
				</AppBar>
			</div>
		);
	}
};